import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { INCIDENT_API } from "./apiRoutes";

interface UseGetIncidentProps {
  id: string;
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getIncidentById = async (id: string, communityId: string) =>
  await axiosAuth.get(`${INCIDENT_API(communityId)}/${id}`);

const useGetIncidentById = ({
  queryParams,
  id,
  communityId
}: UseGetIncidentProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["incident-by-id", id],
    queryFn: () => getIncidentById(id, communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!id || queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetIncidentById;
